export const MY_SPACE_SCOUT_API_KEY_NAME = 'My Space Scout';

export interface IUserApiKey {
  id: number;
  name: string;
  key_prefix: string;
  scope: string;
  created_at: string;
}

export interface IUserApiKeyCreated extends IUserApiKey {
  key: string;
}
